// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.IconFiles = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.IconFiles = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var IconFiles = _exports.IconFiles = function IconFiles(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.8491 19.0038C15.4002 19.0038 15.9287 18.7849 16.3184 18.3952C16.7081 18.0055 16.927 17.477 16.927 16.9259V8.49512C16.927 8.12785 16.7811 7.77563 16.5214 7.5159L10.4063 1.40074C10.1465 1.14107 9.7943 0.995173 9.42703 0.995117H5.15214C4.60104 0.995117 4.07251 1.21404 3.68283 1.60373C3.29314 1.99341 3.07422 2.52194 3.07422 3.07304V16.9259C3.07422 17.477 3.29314 18.0055 3.68283 18.3952C4.07251 18.7849 4.60104 19.0038 5.15214 19.0038H10.0006",
      stroke: "#6B6F76",
      "stroke-width": "0.56338",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10 1.34131V6.53611C10 6.90351 10.1459 7.25586 10.4057 7.51566C10.6655 7.77545 11.0179 7.9214 11.3853 7.9214H16.5801",
      stroke: "#6B6F76",
      "stroke-width": "0.56338",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.4216 17.3236H10.3652M12.3934 15.2954V19.3517V15.2954Z",
      stroke: "#6B6F76",
      "stroke-width": "0.56338",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }));
  };
});
